import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './mask.css';

class MaskControl extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

	render() {
    const self = this,
      { props } = self,
      {
        open = false
      } = props;

    return (
      open ? (
        <div className='mask-component'>
          <img alt='' src='https://static.tigerairtw.com/images/2020loading.gif'></img>
          <div></div>
        </div>
      ) : null
    );
	}
}

MaskControl.propTypes = {
	open: PropTypes.bool,
	fullSize: PropTypes.bool
};

export default MaskControl;
